import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import RootReducer from './reducers/RootReducer';
import { persistStore, persistReducer } from 'redux-persist';
import localforage from 'localforage';

const persistConfig = {
    key: 'root',
    storage: localforage,  // ✅ Ensure storage engine is correct
    version: 1,
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const Store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(thunk),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(Store);

export default Store;
